module.exports = __webpack_public_path__ + "img/10.a38c7dc2.png";